import { render } from "./PageFrame.vue?vue&type=template&id=be351ffe&scoped=true"
import script from "./PageFrame.vue?vue&type=script&lang=js"
export * from "./PageFrame.vue?vue&type=script&lang=js"

import "./PageFrame.vue?vue&type=style&index=0&id=be351ffe&scoped=true&lang=css"

import exportComponent from "/home/maeda/ocx/ocx-hikari-sale-screenview/self/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be351ffe"]])

export default __exports__